import type { GeneratorOptions, Schema } from '@cli-types/core-engine/schema.js'
import type { SinglePageGeneratorResult } from '@cli-types/next-adapter/generators.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { singularize, toPascalCase } from '@cli-utils/text.js'
import { resolveSchemaActionImportPath } from '@next-adapter/config/paths/resolve-schema-action-import-path.js'
import { buildSingleDevModeIntegration } from '@next-adapter/generators/dev-mode-integration/build-single-dev-mode-integration.js'
import { renderSinglePageRenderer } from '@next-adapter/templates/renderers/generators/single-page.js'

export function generateSinglePage(
  schema: Schema,
  pagesDir: string,
  options: GeneratorOptions = {}
): SinglePageGeneratorResult {
  const singular = singularize(schema.name)
  const Singular = toPascalCase(singular)
  const PageName = toPascalCase(schema.name)
  const actionImportPath = resolveSchemaActionImportPath(schema.name, options.outputNamespace)
  const devModeIntegration = buildSingleDevModeIntegration(
    schema,
    options.adminDir ?? 'admin',
    actionImportPath,
    options.adminImportAlias
  )
  const settingsImport =
    schema.name === 'settings' ? '' : "import { getSetting } from '@admin/actions/settings'\n"
  const dataLoad =
    schema.name === 'settings'
      ? renderSinglePageRenderer({
          kind: 'renderSinglePageDataTemplate',
          props: { singular: Singular }
        })
      : renderSinglePageRenderer({
          kind: 'renderSinglePageGeneratedValueTemplate',
          props: { singular: Singular }
        })
  const initialSettingsProp =
    schema.name === 'settings' ? 'initialSettings={data}' : 'initialSettings={initialSettings}'
  const content = renderSinglePageRenderer({
    kind: 'renderSinglePageImportsTemplate',
    props: {
      settingsImport: settingsImport,
      singular: Singular,
      actionImportPath: actionImportPath,
      devModeIntegrationButtonExportName: devModeIntegration.buttonExportName,
      devModeIntegrationButtonImportPath: devModeIntegration.buttonImportPath,
      schemaName: schema.name,
      pageName: PageName,
      dataLoad: dataLoad,
      schemaLabel: schema.label,
      initialSettingsProp: initialSettingsProp
    }
  })

  return {
    files: [
      createGeneratedFile(`${pagesDir}/${schema.name}/page.tsx`, content),
      ...devModeIntegration.files
    ]
  }
}
